import isEmpty from "./isEmpty";

export default function isValidUserName(value: string): boolean {
  return !isEmpty(value)
}
